module.exports = __webpack_public_path__ + "assets/images/pedra_mais_a0e6e9045d2ca7b69dc49e019cfc3eef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tela-montanha/pedra_mais.png
// module id = 168
// module chunks = 0